export default {
    Allow: 1,
    NotAllow: 2,
    NotAllowAndConvert: 4
}